import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../Components/MainLayout/Header";
import Axios from "axios";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Payments extends Component {
  state = { exam: [], loading: false, fakeData: [1, 2] };

  componentDidMount() {
    this.fetchfee({
      session: this.props.user.student_info.session.id,
      exam_system_term__exam_system__exam_system_class_data__for_class: this
        .props.user.student_class.id,
    });
  }

  fetchfee = (params = {}) => {
    this.setState({ loading: true });
    Axios.get(`/api/examssytemtype`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({ exam: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header to="/home" title="Exam Schedule" />
        {this.state.loading ? (
          <div className="container pt-3">
            {this.state.fakeData?.map((item, index) => {
              return (
                <div className="d-flex flex-wrap">
                  {this.state.fakeData?.map((item, index) => {
                    return (
                      <div key={index} className="col-6 px-1">
                        <div className="btn mt-2 border rounded btn-block p-1">
                          <Skeleton />
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="container pt-3 pb-5">
            <p className="th-14 th-bold mb-2">Exam Type</p>
            {this.state.exam.length === 0 ? (
              <p className="th-12 text-center py-5">No Exam for Now.</p>
            ) : (
              <div className="row p-2">
                {this.state.exam?.map((item, index) => {
                  return (
                    <div className="col-6 px-1" key={index}>
                      <Link
                        type="button"
                        className="btn mt-2 th-att-btn btn-block"
                        to={`/examScheduledetail/${item.id}`}
                      >
                        {item.exam_type.exam_type}
                      </Link>
                    </div>
                  );
                })}
              </div>
            )}
            <div className="py-3"></div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps)(Payments);
